import { HE } from "../types";

class EventEmitter {
  private listeners: { [key: string]: Function[] } = {};

  constructor() {}

  on(event: string, listener: Function) {
    if (!this.listeners[event]) {
      this.listeners[event] = [listener];
    } else {
      this.listeners[event].push(listener);
    }
  }

  emit(event: string, ...args: any[]) {
    let fns: Function[] = this.listeners[event] || [];

    fns.forEach((fn) => {
      fn.apply(this, args);
    });
  }
}

export default EventEmitter;
